import NuiAccordion from '../../nui-accordion/NuiAccordion';
import Anchor from './Anchor';
import ShowLogged from './ShowLogged';
import ShowUnlogged from './ShowUnlogged';
import { ContactForm } from '../../contact/ContactForm';

export default {
    accordeon: NuiAccordion,
    anchor: Anchor,
    contact_us_form: ContactForm,
    logged: ShowLogged,
    unlogged: ShowUnlogged
};
